const PAGE_ERROR_CODES = [
  'no_active_subscription',
  'payment_failed',
  'subscription_paused',
  'subscription_suspended',
  'scheduled_for_cancellation',
  'scheduled_change_pending',
  'renewal_in_progress',
  'no_upgrade_available',
]

// Long enough to read the toast before leaving the page.
export const REDIRECT_DELAY_MS = 3000

export const pageErrorMessageKey = (code) => (
  PAGE_ERROR_CODES.includes(code)
    ? `subscription_checkout.plans_restructure.upgrade.page_errors.${code}`
    : 'subscription_checkout.intent_update_error'
)

export const COMMIT_ERROR_KEY = 'subscription_checkout.plans_restructure.upgrade.commit_errors'
